import moment from 'moment';
import { CloseIcon, EditIcon, UserIcon } from 'assets/icons';
import { Globals } from 'utils';

interface ModalViewCompanyProps {
  user?: any
  onClose: () => void
  onEdit?: () => void
}

const ModalViewCompany = ({ user, onClose, onEdit }: ModalViewCompanyProps) => {
  const photo = user?.photo ? Globals.fromStorage(user.photo) : UserIcon;

  return (
    <div>
      <button className="close-btn" onClick={onClose}>
        <img src={CloseIcon} alt="Cerrar" />
      </button>

      <section className="head">
        <div className="user-photo">
          <img src={photo} alt="Usuario" />
        </div>
        <div style={{ gridColumnStart: 2, gridColumnEnd: 4 }}>
          <div className="user-name">
            <p>{ user?.company_name }</p>
          </div>
          <div className="actions">
            <button onClick={onEdit}>
              <img src={EditIcon} alt="Editar" />
              <span>Editar</span>
            </button>
          </div>
        </div>
      </section>

      <section className="body">
        <div className="details">
          <div className="created-at">
            <span>Fecha de registro: { moment(user?.created_at).format('DD-MM-YYYY') }</span>
          </div>
          <p><label>RIF:</label> { user?.company_full_document }</p>
          <p><label>Teléfono:</label> { user?.company_full_phone }</p>
          <p><label>Correo:</label> { user?.company_email }</p>
          <p><label>Dirección:</label> { user?.address }</p>

          <p className="section">Persona de contacto</p>
          <p><label>Nombre:</label> { user?.full_name }</p>
          <p><label>Teléfono:</label> { user?.full_phone }</p>
        </div>
      </section>
    </div>
  );
}

export default ModalViewCompany;